import { Users, Home, User, Layers, Repeat, PenLine, Wallet } from 'lucide-react'
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar'
import type { ScopeFilter, ExpenseTypeFilter, PaidByFilter } from '@/lib/utils'
import type { Profile } from '@/lib/hooks/use-profiles'

const iconClass = 'size-3.5'

export const SCOPE_LABEL = 'どこの支出？'
export const SCOPE_OPTIONS: { value: ScopeFilter; label: string; icon: React.ReactNode }[] = [
  { value: 'all', label: 'すべて', icon: <Users className={iconClass} /> },
  { value: 'household', label: '家計', icon: <Home className={iconClass} /> },
  { value: 'personal', label: '個人', icon: <User className={iconClass} /> },
]

export const EXPENSE_TYPE_LABEL = 'どんな支出？'
export const EXPENSE_TYPE_OPTIONS: { value: ExpenseTypeFilter; label: string; icon: React.ReactNode }[] = [
  { value: 'all', label: 'すべて', icon: <Layers className={iconClass} /> },
  { value: 'fixed', label: '固定費（繰り返しの支出）', icon: <Repeat className={iconClass} /> },
  { value: 'variable', label: '変動費', icon: <PenLine className={iconClass} /> },
]

export const PAID_BY_LABEL = 'だれが払った？'

export function buildPaidByOptions(profiles: Profile[]): { value: PaidByFilter; label: string; icon: React.ReactNode }[] {
  return [
    { value: 'all', label: 'すべて', icon: <Wallet className={iconClass} /> },
    ...profiles.map((p) => ({
      value: p.id as PaidByFilter,
      label: p.display_name,
      icon: (
        <Avatar className="size-3.5">
          {p.avatar_url && <AvatarImage src={p.avatar_url} alt={p.display_name} />}
          <AvatarFallback className="text-[6px]">{p.display_name.charAt(0)}</AvatarFallback>
        </Avatar>
      ),
    })),
  ]
}
